// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.why-choose-us-container {
  font-family: "Proxima Nova", sans-serif;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.why-choose-us-container .nav {
  height: 80px;
  padding: 15px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.why-choose-us-container .navigation {
  width: 265px;
  height: 48px;
  padding: 8px;
  display: flex;
  align-items: center;
  background-color: #F9F9F9;
  border-radius: 23px;
}
.why-choose-us-container .navigation li {
  border-radius: 16px;
  background-color: #F9F9F9;
  color: #949494;
  font-size: 16px;
  width: 83px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: 0.3s ease-in-out;
}
.why-choose-us-container .navigation li.active {
  font-weight: 700;
  color: white;
  background-color: var(--primary-color-1);
}
.why-choose-us-container .buyers-details, .why-choose-us-container .sellers-details, .why-choose-us-container .agents-details {
  animation: fadein 1s;
}
.why-choose-us-container .header {
  font-size: 40px;
  font-weight: 700;
  color: var(--secondary-color-1);
  margin: 0;
  text-align: center;
}
.why-choose-us-container .subheader {
  font-size: 20px;
  font-weight: 400;
  color: #949494;
  line-height: 28px;
  margin: 0;
  text-align: center;
}
.why-choose-us-container .content {
  font-size: 16px;
  line-height: 30px;
  color: var(--secondary-color-1);
}
.why-choose-us-container .title {
  font-size: 28px;
  font-weight: 700;
  color: var(--secondary-color-1);
  margin: 0;
  line-height: 40px;
}
.why-choose-us-container .blocks {
  display: flex;
  gap: 16px;
  flex-wrap: wrap;
}
.why-choose-us-container .blocks img {
  max-width: 224px;
}
.why-choose-us-container .blocks div {
  display: flex;
  gap: 16px;
  flex: 1 1;
}
.why-choose-us-container .blocks .card {
  display: flex;
  flex-direction: column;
  padding: 32px;
  background-color: #F9F9F9;
  border-radius: 24px;
  row-gap: 24px;
}
.why-choose-us-container .blocks .card .content {
  line-height: 24px;
}
.why-choose-us-container .blocks .card .title {
  font-size: 24px;
  font-weight: 700;
  line-height: 30px;
}

@media (min-width: 481px) and (max-width: 767px), (min-width: 320px) and (max-width: 480px) {
  .why-choose-us-container .title {
    text-align: center;
  }
  .why-choose-us-container .blocks {
    flex-direction: column;
    align-items: center;
  }
  .why-choose-us-container .blocks div {
    align-items: center;
    flex-direction: column;
    width: 100%;
    max-width: none !important;
  }
  .why-choose-us-container .blocks .image-resize {
    max-width: none !important;
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/routes/WhyChooseUs/whyChooseUs.scss","webpack://./src/assets/styles/_mixins.scss"],"names":[],"mappings":"AAEA;EACI,uCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AADJ;AAEI;EACI,YAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAAR;AAEI;EACI,YAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,mBAAA;AAAR;AACQ;EACI,mBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,4BAAA;AACZ;AAAY;EACI,gBAAA;EACA,YAAA;EACA,wCAAA;AAEhB;AAEI;EACI,oBAAA;AAAR;AAEI;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,SAAA;EACA,kBAAA;AAAR;AAEI;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;AAAR;AAEI;EACI,eAAA;EACA,iBAAA;EACA,+BAAA;AAAR;AAEI;EACI,eAAA;EACA,gBAAA;EACA,+BAAA;EACA,SAAA;EACA,iBAAA;AAAR;AAEI;EACI,aAAA;EACA,SAAA;EACA,eAAA;AAAR;AACQ;EACI,gBAAA;AACZ;AACQ;EACI,aAAA;EACA,SAAA;EACA,SAAA;AACZ;AACQ;EACI,aAAA;EACA,sBAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;AACZ;AAAY;EACI,iBAAA;AAEhB;AAAY;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;AAEhB;;AC/FY;EDqGJ;IACI,kBAAA;EAFV;EAIM;IACI,sBAAA;IACA,mBAAA;EAFV;EAGU;IACI,mBAAA;IACA,sBAAA;IACA,WAAA;IACA,0BAAA;EADd;EAGU;IACI,0BAAA;IACA,WAAA;EADd;AACF","sourcesContent":["@import 'assets/styles/_mixins.scss';\n\n.why-choose-us-container {\n    font-family: 'Proxima Nova', sans-serif;    \n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    .nav {\n        height: 80px;\n        padding: 15px;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n    .navigation {\n        width: 265px;\n        height: 48px;\n        padding: 8px;\n        display: flex;\n        align-items: center;\n        background-color: #F9F9F9;\n        border-radius: 23px;\n        li {\n            border-radius: 16px;\n            background-color: #F9F9F9;\n            color: #949494;\n            font-size: 16px;\n            width: 83px;\n            height: 32px;\n            display: flex;\n            align-items: center;\n            justify-content: center;\n            cursor: pointer;\n            transition: .3s ease-in-out;\n            &.active {\n                font-weight: 700;\n                color: white;\n                background-color: var(--primary-color-1);\n            }\n        }\n    }\n    .buyers-details, .sellers-details, .agents-details {\n        animation: fadein 1s;\n    }\n    .header {\n        font-size: 40px;\n        font-weight: 700;\n        color: var(--secondary-color-1);\n        margin: 0;\n        text-align: center;\n    }\n    .subheader {\n        font-size: 20px;\n        font-weight: 400;\n        color: #949494;\n        line-height: 28px;\n        margin: 0;\n        text-align: center;\n    }\n    .content {\n        font-size: 16px;\n        line-height: 30px;\n        color: var(--secondary-color-1);\n    }\n    .title {\n        font-size: 28px;\n        font-weight: 700;\n        color: var(--secondary-color-1);\n        margin: 0;\n        line-height: 40px;\n    }\n    .blocks {\n        display: flex;\n        gap: 16px;\n        flex-wrap: wrap;\n        img {\n            max-width: 224px;\n        }\n        div {\n            display: flex;\n            gap: 16px;\n            flex: 1;\n        }\n        .card {\n            display: flex;\n            flex-direction: column;\n            padding: 32px;\n            background-color: #F9F9F9;\n            border-radius: 24px;\n            row-gap: 24px;\n            .content {\n                line-height: 24px;\n            }\n            .title {\n                font-size: 24px;\n                font-weight: 700;\n                line-height: 30px;\n            }\n        }\n    }\n}\n\n@include media(mobile) {\n    .why-choose-us-container {\n        .title {\n            text-align: center;\n        }\n        .blocks {\n            flex-direction: column;\n            align-items: center;\n            div {\n                align-items: center;\n                flex-direction: column;\n                width: 100%;\n                max-width: none !important;\n            }\n            .image-resize {\n                max-width: none !important;\n                width: 100%;\n            }\n        }\n    }\n}","@mixin media($keys...) {\r\n    @each $key in $keys {\r\n        @if ($key==mobile) {\r\n            @media (min-width: 481px) and (max-width: 767px),\r\n            (min-width: 320px) and (max-width: 480px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==tablet) {\r\n            @media (min-width: 768px) and (max-width: 1024px),\r\n            (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==nitty-gritt) {\r\n            @media (width: 1024px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==small-desktop) {\r\n            @media (max-width: 1440px) and (max-height: 833px) {\r\n                @content;\r\n            }\r\n        }\r\n\r\n        @else if ($key==desktop) {\r\n            @media (min-width: 1024px) and (max-width: 1440px) {\r\n                @content;\r\n            }\r\n        }\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
